export interface IEmailTemplateSellToUs {
  subject: string;
  header_text: string;
  date_and_time_phrase: string;
  name_phrase: string;
  message_phrase: string;
  phone_phrase: string;
  company_phrase: string;
  email_address_phrase: string;
  email_has_been_sent_phrase: string;
}
